export default __webpack_public_path__ + "static/media/sliderimg-consulting.9806e2e5.jpg";